import { Link, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ForgetMeNotIcon } from "../components/ForgetMeNotIcon";
import { useAuth } from "../lib/AuthContext";
import { SiteNav } from "../components/SiteNav";

export default function Welcome() {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]" data-testid="welcome-loading">
                <ForgetMeNotIcon size={48} className="animate-pulse" />
            </div>
        );
    }
    if (!user || user === false) return <Navigate to="/sign-in" replace />;

    return (
        <div className="min-h-screen bg-[#FDFBF7]" data-testid="welcome-page">
            <SiteNav />
            <main className="pt-32 pb-24 px-6 rem-watercolor-bg min-h-screen">
                <motion.div
                    initial={{ opacity: 0, y: 14 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="max-w-3xl mx-auto"
                >
                    <div className="flex justify-center mb-8">
                        <ForgetMeNotIcon size={56} />
                    </div>
                    <p className="text-center font-sans text-xs uppercase tracking-[0.3em] text-[#6B7DB8] font-semibold mb-5">
                        Welcome to remembr
                    </p>
                    <h1 className="text-center font-serif text-4xl sm:text-5xl text-[#2D2B2A] leading-tight" data-testid="welcome-heading">
                        Good morning, <em className="italic text-[#4A5A95]">{user.name || user.email.split("@")[0]}</em>
                    </h1>

                    <div className="mt-12 rem-greeting-card rounded-[2rem] p-10">
                        <h2 className="font-serif text-2xl text-[#2D2B2A] mb-3">Your family's profile builder is coming next.</h2>
                        <p className="text-[#5C5A59] leading-relaxed font-light">
                            You're on the very early list — thank you for being here.
                            We're hand-building remembr right now. When the profile builder, family invitations,
                            and remembr Mode are ready for your family, you'll be among the first we welcome in.
                        </p>
                        <p className="mt-5 text-[#5C5A59] leading-relaxed font-light">
                            In the meantime, take a wander back through John Tilly's story — and if you have a moment,
                            tell us who you're building this for. Every name we hear shapes what we build next.
                        </p>
                        <div className="mt-7 flex flex-wrap gap-3">
                            <Link
                                to="/#john"
                                className="px-5 py-2.5 rounded-full bg-[#6B7DB8] hover:bg-[#4A5A95] text-white text-sm font-medium transition-all hover:-translate-y-0.5"
                                data-testid="welcome-visit-john"
                            >
                                Re-read John's story
                            </Link>
                            <Link
                                to="/#pricing"
                                className="px-5 py-2.5 rounded-full bg-white border border-[#E5E1D8] hover:border-[#8C9ECB] text-[#4A5A95] text-sm font-medium transition-all hover:-translate-y-0.5"
                                data-testid="welcome-visit-pricing"
                            >
                                Reserve a remembr
                            </Link>
                        </div>
                    </div>
                </motion.div>
            </main>
        </div>
    );
}
